import { IListFilterProps } from '../../components/jobBoard/ListFilter';
import { DateTimeFormat as CommonDateTimeFormat, SortDirectionEnum } from './CommonConstants';
import { FileMIME } from '../../models/File';

export class UserRoleType {
  public static readonly SUPPLIER = 'supplier';
  public static readonly BUYER = 'buyer';
  public static readonly ADMIN = 'admin';
}

export enum UserRoleID {
  BUYER = 1,
  SUPPLIER = 2,
}

export type RoleKeys = 'buyer' | 'supplier' | 'admin';

export enum PostedByEnum {
  ALL = 'all',
  BUYER = 'buyer',
  ADMIN = 'admin',
}
export enum ReplyEnum {
  ALL = 'all',
  REPLIED = 'replied',
  NO_REPLY = 'no_reply',
}
export enum SortByEnum {
  CREATE_DATE = 'create_date',
  NAME = 'name',
  CLOSE_DATE = 'close_date',
  PROJECT_VALUE = 'project_value',
}
export enum JobStatusEnum {
  OPEN = 'open',
  CLOSED = 'closed',
  UPCOMING = 'upcoming',
  PENDING = 'pending',
  CANCELLED = 'cancelled',
}
export enum JobShortlistStatusEnum {
  WAITING = 'waiting',
  SHORTLISTED = 'shortlisted',
  NO_SUPPLIER_SHORTLISTED = 'no_suppliers_shortlisted',
}
export enum JobTypeEnum {
  EASY_QUOTE = 'easy_quote',
  RFI = 'rfi',
  RFP = 'rfp',
  RFQ = 'rfq',
  RFBQ = 'rfbq',
}
export enum JobOpenDateEnum {
  ALL = 'all',
  LAST_7_DAYS = 'last_7_days',
  LAST_14_DAYS = 'last_14_days',
  LAST_1_MONTH = 'last_1_month',
}

export enum OfferingOpenDateEnum {
  ALL = 'all',
  LAST_7_DAYS = 'last_7_days',
  LAST_14_DAYS = 'last_14_days',
  LAST_30_DAYS = 'last_30_days',
}

export enum JobCloseDateEnum {
  ALL = 'all',
  WITHIN_TOMORROW = 'within_tomorrow',
  WITHIN_3_DAYS = 'within_3_days',
  WITHIN_7_DAYS = 'within_7_days',
}
export enum JobDisplayTypeEnum {
  ALL = 'all',
  RECOMMENDED = 'recommended',
}

export const ReplyDisplay = {
  [ReplyEnum.ALL]: 'Common.Label.All',
  [ReplyEnum.REPLIED]: 'BuyingLead.Label.HavingResponses',
  [ReplyEnum.NO_REPLY]: 'BuyingLead.Label.NoResponses',
};

export const JobStatusDisplay = {
  [JobStatusEnum.OPEN]: 'BuyingLead.Status.Open',
  [JobStatusEnum.CLOSED]: 'BuyingLead.Status.Closed',
  [JobStatusEnum.UPCOMING]: 'BuyingLead.Status.Upcoming',
  [JobStatusEnum.PENDING]: 'BuyingLead.Status.Pending',
  [JobStatusEnum.CANCELLED]: 'BuyingLead.Status.Cancelled',
};

export const JobShortlistStatusDisplay = {
  [JobShortlistStatusEnum.WAITING]: 'BuyingLead.Status.AwaitingShortlist',
  [JobShortlistStatusEnum.SHORTLISTED]: 'BuyingLead.Status.Shortlisted',
  [JobShortlistStatusEnum.NO_SUPPLIER_SHORTLISTED]: 'BuyingLead.Status.NoSuppliersShortlisted',
};

export const JobShortlistStatusDisplayForSupplier = {
  [JobShortlistStatusEnum.WAITING]: 'BuyingLead.Status.AwaitingShortlist',
  [JobShortlistStatusEnum.SHORTLISTED]: 'BuyingLead.Status.Win',
  [JobShortlistStatusEnum.NO_SUPPLIER_SHORTLISTED]: 'BuyingLead.Status.Lost',
};

export const JobTypeDisplay = {
  [JobTypeEnum.EASY_QUOTE]: 'Easy Quote',
  [JobTypeEnum.RFI]: 'RFI',
  [JobTypeEnum.RFP]: 'RFP',
  [JobTypeEnum.RFQ]: 'RFQ',
  [JobTypeEnum.RFBQ]: 'RFBQ',
};

export const JobOpenDateDisplay = {
  [JobOpenDateEnum.ALL]: 'BuyingLead.BuyingLeadsList.FilterToolbar.Label.AllOpenDate',
  [JobOpenDateEnum.LAST_7_DAYS]: 'BuyingLead.BuyingLeadsList.FilterToolbar.Label.last7Days',
  [JobOpenDateEnum.LAST_14_DAYS]: 'BuyingLead.BuyingLeadsList.FilterToolbar.Label.last14Days',
  [JobOpenDateEnum.LAST_1_MONTH]: 'BuyingLead.BuyingLeadsList.FilterToolbar.Label.last1Month',
};

export const OfferingOpenDateDisplay = {
  [OfferingOpenDateEnum.ALL]: 'BuyingLead.BuyingLeadsList.FilterToolbar.Label.AllOpenDate',
  [OfferingOpenDateEnum.LAST_7_DAYS]: 'BuyingLead.BuyingLeadsList.FilterToolbar.Label.last7Days',
  [OfferingOpenDateEnum.LAST_14_DAYS]: 'BuyingLead.BuyingLeadsList.FilterToolbar.Label.last14Days',
  [OfferingOpenDateEnum.LAST_30_DAYS]: 'BuyingLead.BuyingLeadsList.FilterToolbar.Label.last1Month',
};

export const JobCloseDateDisplay = {
  [JobCloseDateEnum.ALL]: 'BuyingLead.BuyingLeadsList.FilterToolbar.Label.AllCloseDate',
  [JobCloseDateEnum.WITHIN_TOMORROW]:
    'BuyingLead.BuyingLeadsList.FilterToolbar.Label.withinTomorrow',
  [JobCloseDateEnum.WITHIN_3_DAYS]: 'BuyingLead.BuyingLeadsList.FilterToolbar.Label.within3Days',
  [JobCloseDateEnum.WITHIN_7_DAYS]: 'BuyingLead.BuyingLeadsList.FilterToolbar.Label.within7Days',
};
export const JobDisplayTypeDisplay = {
  [JobDisplayTypeEnum.ALL]: 'BuyingLead.BuyingLeadsList.FilterToolbar.Label.all',
  [JobDisplayTypeEnum.RECOMMENDED]: 'BuyingLead.BuyingLeadsList.FilterToolbar.Label.Recommended',
};

const sortByDefault = {
  sortBy: SortByEnum.CREATE_DATE,
  sortDir: SortDirectionEnum.DESC,
};

export enum JobBoardRoute {
  JOB_LIST = '/list',
  JOB_DETAIL = '/detail/:jobID',
  JOB_ERFX = '/erfx/:erfxNo',
  REPORT = '/report',
  TUTORIAL = '/tutorial',
}

export const BuyerJobBoardFilterDefault: IListFilterProps = {
  filters: [
    {
      title: 'Common.Label.SortBy',
      value: sortByDefault,
      items: [
        {
          label: 'Common.Label.Latest',
          val: sortByDefault,
        },
        {
          label: 'Common.Label.LaBel_A_Z',
          val: {
            sortBy: SortByEnum.NAME,
            sortDir: SortDirectionEnum.ASC,
          },
        },
        {
          label: 'Common.Label.LaBel_Z_A',
          val: {
            sortBy: SortByEnum.NAME,
            sortDir: SortDirectionEnum.DESC,
          },
        },
      ],
    },
    {
      title: 'BuyingLead.Label.Responses',
      value: { reply: ReplyEnum.ALL },
      items: [
        {
          label: 'Common.Label.All',
          val: { reply: ReplyEnum.ALL },
        },
        {
          label: 'BuyingLead.Label.HavingResponses',
          val: { reply: ReplyEnum.REPLIED },
        },
        {
          label: 'BuyingLead.Label.NoResponses',
          val: { reply: ReplyEnum.NO_REPLY },
        },
      ],
    },
    {
      title: 'BuyingLead.Label.PostStatus',
      value: { status: JobStatusEnum.OPEN },
      items: [
        {
          label: 'Common.Label.All',
          val: { status: [] },
        },
        {
          label: 'BuyingLead.Label.Open',
          val: { status: JobStatusEnum.OPEN },
        },
        {
          label: 'BuyingLead.Label.Cancelled',
          val: { status: JobStatusEnum.CANCELLED },
        },
      ],
    },
  ],
  searchProps: {
    placeholder: 'BuyingLead.Label.SearchForBuyingLeads',
  },
};

export enum BoardTypeEnum {
  ALL,
  BOOKMARKED,
  QUOTE,
}

export const SupplierJobBoardFilterDefault: IListFilterProps = {
  filters: [
    {
      title: 'Common.Label.SortBy',
      value: sortByDefault,
      items: [
        {
          label: 'Common.Label.Latest',
          val: sortByDefault,
        },
        {
          label: 'Common.Label.LaBel_A_Z',
          val: {
            sortBy: SortByEnum.NAME,
            sortDir: SortDirectionEnum.ASC,
          },
        },
        {
          label: 'Common.Label.LaBel_Z_A',
          val: {
            sortBy: SortByEnum.NAME,
            sortDir: SortDirectionEnum.DESC,
          },
        },
      ],
    },
    {
      title: 'BuyingLead.Label.PostStatus',
      value: { status: JobStatusEnum.OPEN },
      items: [
        {
          label: 'Common.Label.All',
          val: { status: [] },
        },
        {
          label: 'BuyingLead.Label.Open',
          val: { status: JobStatusEnum.OPEN },
        },
        {
          label: 'BuyingLead.Label.Cancelled',
          val: { status: JobStatusEnum.CANCELLED },
        },
      ],
    },
  ],
  searchProps: {
    placeholder: 'BuyingLead.Label.SearchForBuyingLeads',
  },
};

export enum ErfxContactSupplierType {
  NEW = 'new',
  INVITED = 'invited',
  INVALID_CONTACT = 'invalid_contact',
  COMPLETED = 'completed',
}

export enum ConversationSortByEnum {
  CREATE_DATE = 'create_date',
}

export type ConversationStatusType = 'active' | 'cancelled';

export type ConversationPrivacyType = 'organization_buyer' | 'me_buyer';

export type ConversationType = 'post' | 'reply';

export class JobAttachmentConst {
  public static readonly acceptanceExtension =
    '.jpeg, .jpg, .gif, .png, .bmp, .tif, .tiff, .pdf, .doc, .docx, .xls, .xlsx, .ppt, .pptx, .txt, .zip, .rar, .msg';
  public static readonly maxFileSizeMb = 5;
  public static readonly maxFileSizeUnit = 'MB';
  public static readonly maxFileSize = this.maxFileSizeMb * 1024 * 1024;

  public static isValidFileType = (type: string) => {
    switch (type) {
      case FileMIME.JPEG:
      case FileMIME.JPG:
      case FileMIME.PNG:
      case FileMIME.PDF:
      case FileMIME.XLS:
      case FileMIME.XLSX:
      case FileMIME.DOC:
      case FileMIME.DOCX:
      case FileMIME.GIF:
      case FileMIME.BMP:
      case FileMIME.TIF:
      case FileMIME.PPT:
      case FileMIME.PPTX:
      case FileMIME.TXT:
      case FileMIME.ZIP:
      case FileMIME.RAR:
      case FileMIME.MSG:
        return true;
      default:
        return false;
    }
  };
}

export enum SupplierRespondedSortingEnum {
  RESPONDED_DATE = 'respondedDate',
  TOTAL_PRICE = 'totalPrice',
  UNIT_PRICE = 'unitPrice',
  SUPPLIER_COMPANY_NAME = 'supplierCompanyName',
}

export class DateTimeFormat {
  public static readonly DATE = CommonDateTimeFormat.DDMMYYYY_SLASH;
  public static readonly TIME = CommonDateTimeFormat.HHmm;
  public static readonly DATE_TIME = `${this.DATE} ${this.TIME}`;
}
